import React from 'react';
import PropTypes from 'prop-types';
import { Button, Modal } from '@gsa/afp-component-library';
import ViewSolicitationStandardItems from './view-solicitation-std-items';

const ViewSolicitationStdItemsModal = ({ closeModal, stdItems }) => {
  return (
    <Modal
      id="view-solicitation-std-items-modal"
      test-id="view-solicitation-std-items-modal"
      title={
        <h1 className="margin-top-5" aria-label="Related Standard Items">
          Related Standard Items
        </h1>
      }
      onClose={closeModal}
      variant="extra-large"
      actions={
        <Button
          type="button"
          variant="unstyled"
          onClick={closeModal}
          label="Cancel"
        />
      }
    >
      <ViewSolicitationStandardItems standardItems={stdItems} />
    </Modal>
  );
};

ViewSolicitationStdItemsModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  stdItems: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default ViewSolicitationStdItemsModal;
